import Axios from 'axios';
import header from './auth/header';

const API_URL =  process.env.API_URL + '/api/v1/';

class BiayaJasaAttachment {
    store(data){
        return Axios.post(API_URL + 'add-biayajasaattachment', data, {headers : header()});
    }
    show(id){
        return Axios.get(API_URL + `biayajasaattachment/${id}`);
    }
}

export default new BiayaJasaAttachment();


// WEBPACK FOOTER //
// ./src/api/biayajasaattachment.js